import FetchUtils from 'src/utils/fetch_utils';

/**
 * Init document agreement checkbox: save answer on change (agree value or empty).
 */
export function initDocumentAgreementEditor(agreementWrap) {
  if (agreementWrap.dataset.bound === 'true') {
    return;
  }

  const input = agreementWrap.querySelector('.js-showing-view-document-agreement-input');
  const saveUrl = agreementWrap.dataset.saveAnswerUrl;
  const questionId = agreementWrap.dataset.questionId;
  const agreeValue = agreementWrap.dataset.agreeValue || 'I understand and agree';

  if (!input || !saveUrl || !questionId) {
    return;
  }

  input.addEventListener('change', () => {
    const text = input.checked ? agreeValue : '';
    const body = new URLSearchParams();
    body.set('question_id', questionId);
    body.set('text', text);
    input.disabled = true;

    fetch(saveUrl, {
      method: 'PUT',
      headers: {
        'x-csrf-token': FetchUtils.CSRFToken(),
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        accept: 'application/json'
      },
      body: body.toString()
    })
      .then(FetchUtils.checkResponseStatus)
      .then((resp) => resp.json())
      .then((response) => {
        if (!response.success) {
          throw { smErrText: (response.errors || ['Unable to save answer.'])[0] };
        }
      })
      .catch((err) => {
        input.checked = !input.checked;
        FetchUtils.handleResponseError(err);
      })
      .finally(() => {
        input.disabled = false;
      });
  });

  agreementWrap.dataset.bound = 'true';
}
